import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";

const TermsOfService = () => {
  return (
    <Col lg="8" md="10">
      <Card className="bg-secondary shadow border-0">
        <CardHeader className="bg-transparent">
          <h2 className="mb-0">Üyelik Hizmet Şartları</h2>
          <p className="text-muted mb-0">Yürürlük tarihi: 6 Şubat 2026</p>
        </CardHeader>
        <CardBody className="px-lg-5 py-lg-5 text-muted">
          <p>
            Bu Üyelik Hizmet Şartları ("Şartlar"), Destination Black Sea -
            Karadeniz Destinasyonu portalına ("Portal") erişiminizi ve kullanım
            koşullarını düzenler. Portal’a kayıt olarak veya Portal’ı kullanarak
            bu Şartlar’ı kabul etmiş olursunuz.
          </p>

          <h4 className="mt-4">1) Hesap ve giriş</h4>
          <ul>
            <li>
              Portala telefon numarası (SMS doğrulama) veya desteklenen üçüncü
              taraf sağlayıcılarla giriş yapabilirsiniz.
            </li>
            <li>
              Hesap güvenliğinden (cihaz güvenliği, doğrulama kodlarının
              paylaşılmaması vb.) siz sorumlusunuz.
            </li>
          </ul>

          <h4 className="mt-4">2) Kabul edilebilir kullanım</h4>
          <ul>
            <li>Hukuka aykırı, yanıltıcı veya kötüye kullanım amaçlı faaliyetler yasaktır.</li>
            <li>Sistemin güvenliğini zayıflatmaya yönelik girişimler yasaktır.</li>
            <li>Başkalarının haklarını ihlal eden içerik ve davranışlar yasaktır.</li>
          </ul>

          <h4 className="mt-4">3) İçerik ve sorumluluk</h4>
          <p>
            Portal’da sunulan içerikler bilgilendirme amaçlı olabilir. Portal
            kapsamındaki içeriklerin doğruluğu, güncelliği veya belirli bir amaca
            uygunluğu konusunda mutlak garanti verilmez.
          </p>

          <h4 className="mt-4">4) Hizmetin durdurulması ve hesap sonlandırma</h4>
          <p>
            Güvenlik, bakım, mevzuat gereklilikleri veya kötüye kullanım şüphesi
            gibi durumlarda, hizmete erişimi geçici olarak kısıtlayabilir veya
            hesabınızı sonlandırabiliriz.
          </p>

          <h4 className="mt-4">5) Üçüncü taraf hizmetler</h4>
          <p>
            Portal, kimlik doğrulama ve altyapı için üçüncü taraf hizmetler
            kullanabilir (örn. Firebase/Google, Facebook). Bu hizmetlerin
            kullanımında ilgili üçüncü tarafın şartları geçerli olabilir.
          </p>

          <h4 className="mt-4">6) Değişiklikler</h4>
          <p>
            Şartlar zaman zaman güncellenebilir. Güncellemeler Portal’da
            yayımlandığı tarihten itibaren geçerli olur.
          </p>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TermsOfService;
